/**
 * Copyright © 2018 Emu Analytics
 */
import FormData from 'form-data';
import { IUpload } from './api-interfaces';
import { BaseEndpoints } from './base.endpoints';
import { Client } from './client';

declare var process: any;

export interface UploadOptions {
  data: any;
  filename: string;
  datasetId?: string;
  datasetName?: string;
  datasetDescription?: string;
  attribution?: string;
  sourceSrid?: number;
  targetSrid?: number;
  schema?: string;
  metadata?: any;
  abortController?: AbortController;
  progress?: (event: any) => void;
}

export class UploadEndpoints extends BaseEndpoints<IUpload> {
  constructor(client: Client) {
    super(client, 'uploads');
  }

  async upload(options: UploadOptions, params: Record<string, any> = {}): Promise<IUpload> {
    const form = new FormData();
    if (options.datasetName) {
      form.append('name', options.datasetName);
    }
    if (options.datasetDescription) {
      form.append('description', options.datasetDescription);
    }
    if (options.attribution) {
      form.append('attribution', options.attribution);
    }
    if (options.datasetId) {
      form.append('datasetId', options.datasetId);
    }
    if (options.sourceSrid) {
      form.append('sourceSrid', options.sourceSrid);
    }
    if (options.targetSrid) {
      form.append('targetSrid', options.targetSrid);
    }
    if (options.schema) {
      form.append('schema', options.schema);
    }
    if (options.metadata) {
      form.append('metadata', JSON.stringify(options.metadata));
    }
    form.append('file', options.data, options.filename);

    const upload: IUpload = await this.client._post(this.resourceEndpoint, form, {
      // Note - only Node FormData supports getHeaders
      headers: form.getHeaders?.() ?? { 'Content-Type': 'multipart/form-data' },
      // Add abort signal
      signal: options.abortController?.signal,
      params,
      // Note that progress only works in the browser!!
      onUploadProgress: options.progress
    });

    return upload;
  }
}
